import { ApiCoupon } from '@/models/api/coupon'
import { CouponError } from '@spa/services/api/purchase/discount'
import { none, Option, Some } from 'fp-ts/lib/Option'

/**
 * - 選択したクーポンが適用できない場合
 * - 選択したクーポンによって割引が発生しない場合
 * はcouponがnoneとなり、errorが発生している
 */
export interface ApplyCouponState {
  coupon: Option<ApiCoupon>
  discount: number
  errors: CouponError[]
}

/**
 * クーポンが適用された状態
 */
export class AppliedCouponState implements ApplyCouponState {
  constructor(
    private _coupon: ApiCoupon,
    private _discount: number
  ) {}
  get coupon(): Some<ApiCoupon> {
    return new Some(this._coupon)
  }
  get discount(): number {
    return this._discount
  }
  get errors(): never[] {
    return []
  }
}

/**
 * クーポンを適用しようとしたが適用不可だった状態
 */
export class NotApplicableCouponState implements ApplyCouponState {
  constructor(
    private _errors: [ CouponError, ...CouponError[] ]
  ) {}
  get coupon(): Option<never> {
    return none
  }
  get discount(): number {
    return 0
  }
  get errors(): [ CouponError, ...CouponError[] ] {
    return this._errors
  }
}

/**
 * クーポンの適用を試みていない状態
 */
export class NotApplyingCouponState implements ApplyCouponState {
  get coupon(): Option<never> {
    return none
  }
  get discount(): 0 {
    return 0
  }
  get errors(): never[] {
    return []
  }
}
